export default __webpack_public_path__ + "static/media/p_top_img.ab8cdb40.jpg";